import * as Sentry from "@sentry/gatsby";

const sentryDsn = process.env.GATSBY_SENTRY_DSN;

if (sentryDsn) {
    Sentry.init({
        dsn: sentryDsn,
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true
    });
}

export default Sentry;
